import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { RutterJob } from './rutter-job.entity';

export class CreateRutterJobDto extends Omit(RutterJob, [...BaseEntityFieldsArray]) {}
